module.exports = __webpack_public_path__ + "static/img/Ollie-Wines.3764dda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ollie-Wines.jpg
// module id = TaOS
// module chunks = 0